if (!customElements.get('yc-image-5col')) {
  class YCImage5Col extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.yc-image-5col__grid');
      if (!this.grid) return;

      this.enableAutoplay = this.dataset.autoplay === 'true';
      this.autoplayInterval = (Number(this.dataset.interval) || 3) * 1000;
      this.autoplayTimer = null;
      this.isInfiniteSetup = false;

      this.init();
      window.addEventListener('resize', this.onResize.bind(this));
    }

    getSetWidth(itemsCount) {
      const allItems = this.grid.children;
      if (allItems.length < itemsCount * 2) return 0;
      const firstClone = allItems[0];
      const firstOriginal = allItems[itemsCount];
      return firstOriginal.offsetLeft - firstClone.offsetLeft;
    }

    startAutoplay() {
      if (!this.enableAutoplay || !this.isInfiniteSetup) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        const itemsCount = this.grid.querySelectorAll('.yc-image-5col__item:not(.is-clone)').length;
        const setWidth = this.getSetWidth(itemsCount);
        if (setWidth === 0) return;
        
        const itemWidth = setWidth / itemsCount;
        this.grid.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      clearInterval(this.autoplayTimer);
    }

    setupInfiniteScroll() {
      if (this.grid.scrollWidth <= this.grid.clientWidth) return;
      if (this.isInfiniteSetup) return;

      const items = Array.from(this.grid.children);
      const itemsCount = items.length;

      const prependFragment = document.createDocumentFragment();
      const appendFragment = document.createDocumentFragment();

      items.forEach(item => {
        const clone1 = item.cloneNode(true);
        clone1.classList.add('is-clone');
        clone1.removeAttribute('data-shopify-editor-block');
        prependFragment.appendChild(clone1);
        
        const clone2 = item.cloneNode(true);
        clone2.classList.add('is-clone');
        clone2.removeAttribute('data-shopify-editor-block');
        appendFragment.appendChild(clone2);
      });

      this.grid.insertBefore(prependFragment, this.grid.firstChild);
      this.grid.appendChild(appendFragment);

      this.isInfiniteSetup = true;

      setTimeout(() => {
        const setWidth = this.getSetWidth(itemsCount);
        if (setWidth > 0) {
          const originalBehavior = this.grid.style.scrollBehavior;
          this.grid.style.scrollBehavior = 'auto';
          this.grid.scrollLeft = setWidth + (setWidth - this.grid.clientWidth) / 2;
          requestAnimationFrame(() => {
            this.grid.style.scrollBehavior = originalBehavior;
          });
        }
      }, 50);
      
      this.setupScrollListener();
    }

    setupScrollListener() {
      let scrollTimeout;
      this.grid.addEventListener('scroll', () => {
        if (!this.isInfiniteSetup) return;

        if (this.enableAutoplay) this.stopAutoplay();

        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const itemsCount = this.grid.querySelectorAll('.yc-image-5col__item:not(.is-clone)').length;
          const setWidth = this.getSetWidth(itemsCount);
          if (setWidth === 0) return;

          if (this.grid.scrollLeft < setWidth * 0.5) {
            const originalSnap = this.grid.style.scrollSnapType;
            const originalBehavior = this.grid.style.scrollBehavior;
            
            this.grid.style.scrollSnapType = 'none';
            this.grid.style.scrollBehavior = 'auto';
            this.grid.scrollLeft += setWidth;
            
            this.grid.offsetHeight; 
            
            this.grid.style.scrollSnapType = originalSnap;
            this.grid.style.scrollBehavior = originalBehavior;
          } else if (this.grid.scrollLeft > setWidth * 1.5) {
            const originalSnap = this.grid.style.scrollSnapType;
            const originalBehavior = this.grid.style.scrollBehavior;
            
            this.grid.style.scrollSnapType = 'none';
            this.grid.style.scrollBehavior = 'auto';
            this.grid.scrollLeft -= setWidth;
            
            this.grid.offsetHeight; 
            
            this.grid.style.scrollSnapType = originalSnap;
            this.grid.style.scrollBehavior = originalBehavior;
          }

          if (this.enableAutoplay) this.startAutoplay();
        }, 150);
      });
    }

    init() {
      if (this.grid.scrollWidth > this.grid.clientWidth) {
        this.setupInfiniteScroll();
      } else if (!this.isInfiniteSetup) {
        this.grid.scrollLeft = (this.grid.scrollWidth - this.grid.clientWidth) / 2;
      }

      if (this.enableAutoplay) {
        this.startAutoplay();
        this.grid.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.grid.addEventListener('mouseleave', this.startAutoplay.bind(this));
        this.grid.addEventListener('touchstart', this.stopAutoplay.bind(this), { passive: true });
        this.grid.addEventListener('touchend', this.startAutoplay.bind(this), { passive: true });
      }
    }

    onResize() {
      if (!this.isInfiniteSetup) {
        if (this.grid.scrollWidth > this.grid.clientWidth) {
          this.setupInfiniteScroll();
        }
      } else {
        const itemsCount = this.grid.querySelectorAll('.yc-image-5col__item:not(.is-clone)').length;
        const setWidth = this.getSetWidth(itemsCount);
        if (setWidth > 0 && setWidth <= this.grid.clientWidth) {
          const clones = this.grid.querySelectorAll('.is-clone');
          clones.forEach(clone => clone.remove());
          this.isInfiniteSetup = false;
        }
      }
    }
  }

  customElements.define('yc-image-5col', YCImage5Col);
}
